import { useState, useContext } from "react";
import {
  platformHandler,
  RequestLoader,
  ToastContext,
} from "../../../hooks/context";
import { addLoyaltyCustomer } from "../../../services/customer";
import { useNavigate } from "react-router-dom";
import { getPlatform, cleanObject, buildDob } from "../../../helpers";

export const useAddCustomerWidgetLogic = ({ closeWidget }) => {
  const [customerName, setCustomerName] = useState("");
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerGender, setCustomerGender] = useState("MALE");
  const [dobDay, setDobDay] = useState("");
  const [dobMonth, setDobMonth] = useState("");
  const [dobYear, setDobYear] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const triggerToast = useContext(ToastContext);
  const navigate = useNavigate();
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { platform } = useContext(platformHandler);

  const handleAddCustomer = () => {
    setIsSubmitting(true);
    setRequestLoaderProgress(30);
    const { date_of_birth } = buildDob({
      dob_day: dobDay,
      dob_month: dobMonth,
      dob_year: dobYear,
    });
    const payload = cleanObject({
      first_name: customerName,
      phone: customerPhoneNumber,
      email: customerEmail,
      gender: customerGender,
      date_of_birth,
    });
    addLoyaltyCustomer(payload)
      .then(() => {
        setIsSubmitting(false);
        setRequestLoaderProgress(100);
        triggerToast("Customer added successfully", "success");
        navigate(getPlatform(platform) + "/customers");
        closeWidget(true);
      })
      .catch((error) => {
        setIsSubmitting(false);
        setRequestLoaderProgress(100);
      });
  };

  return {
    customerName,
    customerEmail,
    customerGender,
    customerPhoneNumber,
    dobDay,
    dobMonth,
    dobYear,
    isSubmitting,
    setDobDay,
    setDobMonth,
    setDobYear,
    setCustomerEmail,
    setCustomerGender,
    setCustomerName,
    setCustomerPhoneNumber,
    handleAddCustomer,
  };
};
